enum ContractStatusesEnum {
  INITIAL = 'INITIAL',
  SENT = 'SENT',
  SIGNED = 'SIGNED',
}

export default ContractStatusesEnum;
